import { FC } from 'react';

import { ImagesApp } from '../../constants/images';
import { useI18nContext } from '../../hooks/contexts/i18n.context';
import * as Style from './styles.tags';

const FaceEnabled: FC = () => {
  const { translate } = useI18nContext();
  return (
    <Style.FaceEnabled id="face-enabled-tag">
      <img id="face-enabled-tag-image" src={ImagesApp.svg.face} alt="Face enabled" />
      <span id="face-enabled-tag-text">{translate(['INFORMATION', 'ACCESS_BY_FACE'])}</span>
    </Style.FaceEnabled>
  );
};

export default FaceEnabled;
